// extracted by mini-css-extract-plugin
module.exports = {"grey":"Footer005_grey__CiIff","light":"Footer005_light__39Q61","block":"Footer005_block__fwwvn","button":"Footer005_button___rdaX","title":"Footer005_title__5g0xE"};